// StoryCategoriesCategory.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import { EMPTY_ARRAY } from '../resource/defaults.js';
import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import DiscoverShowMoreWrapper from '../component/DiscoverShowMoreWrapper.jsx';
import { createCategoryLoader } from '../resource/createCategoryLoader.js';
import useSSRDataMerge from '../hook/useSSRDataMerge.js';

export const loader = createCategoryLoader({
  pathPrefix: 'story-categories',
  categoryType: 'story',
  loaderName: 'StoryCategoriesCategory',
});

const StoryCategoriesCategoryRoute = () => {
  const { data, error, meta = EMPTY_ARRAY } = useLoaderData();

  useSSRDataMerge({
    componentName: 'StoryCategoriesCategory',
    loaderData: data,
    loaderError: error,
  });

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <DiscoverShowMoreWrapper />
    </>
  );
};

export default StoryCategoriesCategoryRoute;
